export const tags = [ // 普通筛选标签
  {
    value: '',
    label: '全 部',
    isChoose: false,
    class: 'tag-all'
  },
  {
    value: 1,
    label: '合同提醒',
    isChoose: false,
    class: 'tag-contract'
  },
  {
    value: 2,
    label: '客户提醒',
    isChoose: false,
    class: 'tag-customer'
  },
  {
    value: 3,
    label: '联系人',
    isChoose: false,
    class: 'tag-contacts'
  },
  {
    value: 4,
    label: '审批提醒',
    isChoose: false,
    class: 'tag-approve'
  },
  {
    value: 5,
    label: '销售机会',
    isChoose: false,
    class: 'tag-sale'
  },
  {
    value: 6,
    label: '跟进记录',
    isChoose: false,
    class: 'tag-follow-up'
  },
  {
    value: 8,
    label: '访客计划',
    isChoose: false,
    class: 'tag-visitor-plan'
  },
  {
    value: 12,
    label: '工作报告',
    isChoose: false,
    class: 'tag-work-statement'
  },
  {
    value: 17,
    label: '销售简报',
    isChoose: false,
    class: 'tag-sales-presentations'
  },
  {
    value: 22,
    label: '工单',
    isChoose: false,
    class: 'tag-work-order'
  },
  {
    value: 25,
    label: '销售自动化',
    isChoose: false,
    class: 'tag-sales-automation'
  }
]
export const timeTags = [ // 时间筛选标签
  {
    value: 0,
    label: '全部',
    isChoose: false,
    class: 'time-tag'
  },
  {
    value: 1,
    label: '今日',
    isChoose: false,
    class: 'time-tag'
  },
  {
    value: 2,
    label: '本周',
    isChoose: false,
    class: 'time-tag'
  },
  {
    value: 3,
    label: '本月',
    isChoose: false,
    class: 'time-tag'
  }
]




// WEBPACK FOOTER //
// ./src/config/message-config.js